import * as React from "react";
import { SVGProps } from "react";

const InternetComputer = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    viewBox="0 0 358 179"
    {...props}
  >
    <linearGradient
      id="a"
      x1={224.785}
      x2={348.066}
      y1={257.754}
      y2={133.458}
      gradientTransform="matrix(1 0 0 -1 0 272)"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset={0.21} stopColor="#f15a24" />
      <stop offset={0.684} stopColor="#fbb03b" />
    </linearGradient>
    <path
      fill="url(#a)"
      d="M271.6 0c-20 0-41.9 10.9-65 32.4-10.9 10.1-20.5 21.1-27.5 29.8 0 0 11.2 12.9 23.5 26.8 6.7-8.4 16.2-19.8 27.3-30.1 20.5-19.2 33.9-23.1 41.6-23.1 28.8 0 52.2 24.2 52.2 54.1 0 29.6-23.4 53.8-52.2 54.1-1.4 0-3-.2-5-.6 8.4 3.9 17.5 6.7 26 6.7 52.8 0 63.2-36.5 63.8-39.1 1.5-6.7 2.4-13.7 2.4-20.9C358.6 40.4 319.6 0 271.6 0z"
    />
    <linearGradient
      id="b"
      x1={133.946}
      x2={10.665}
      y1={106.426}
      y2={230.721}
      gradientTransform="matrix(1 0 0 -1 0 272)"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset={0.21} stopColor="#ed1e79" />
      <stop offset={0.893} stopColor="#522785" />
    </linearGradient>
    <path
      fill="url(#b)"
      d="M87.1 179.8c20 0 41.9-10.9 65-32.4 10.9-10.1 20.5-21.1 27.5-29.8 0 0-11.2-12.9-23.5-26.8-6.7 8.4-16.2 19.8-27.3 30.1-20.5 19-34 23.1-41.6 23.1C58.4 144 35 119.8 35 89.9c0-29.6 23.4-53.8 52.2-54.1 1.4 0 3 .2 5 .6-8.4-3.9-17.5-6.7-26-6.7C13.4 29.6 3 66.1 2.4 68.8.9 75.5 0 82.5 0 89.7c0 49.7 39 90.1 87.1 90.1z"
    />
    <path
      fill="#29abe2"
      fillRule="evenodd"
      d="M127.3 59.7c-5.8-5.6-34-28.5-61-29.3C18.1 29.2 4 64.2 2.7 68.7 12 29.5 46.4.2 87.2 0c33.3 0 67 32.7 91.9 62.2l.1-.1s11.2 12.9 23.5 26.8c0 0 14 16.5 28.8 31 5.8 5.6 33.9 28.2 60.9 29 49.5 1.4 63.2-35.6 63.9-38.4-9.1 39.5-43.6 68.9-84.6 69.1-33.3 0-67-32.7-92-62.2 0 .1-.1.1-.1.2 0 0-11.2-12.9-23.5-26.8.1 0-13.9-16.6-28.8-31.1zM2.7 69.1c0-.1 0-.2.1-.3-.1.1-.1.2-.1.3z"
      clipRule="evenodd"
    />
  </svg>
);

export default InternetComputer;
